import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";

const BasicInformationFields = ({ title, formData, handleFormDataChange, statesList, districtList }) => {
    const emailValue = formData.email || "";
    const isEmailInvalid = emailValue !== "" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);

    const handleSelectChange = (fieldName) => (event) => {
        handleFormDataChange({
            target: {
                name: fieldName,
                value: event.target.value,
            },
        });
    };

    return (
        <div className="row">
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label={`${title} Name *`}
                        name="company_name"
                        value={formData.company_name || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 50 }}
                    />
                </FormControl>
            </div>
            
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <InputLabel id="beneficiary-state-label">State *</InputLabel>
                    <Select
                        labelId="beneficiary-state-label"
                        id="state_id"
                        name="state_id"
                        value={String(formData.state_id || "")}
                        label="State *"
                        onChange={handleSelectChange("state_id")}
                    >
                        <MenuItem value="">--Select State--</MenuItem>
                        {statesList.map((state) => (
                            <MenuItem value={String(state.id)} key={state.id}>
                                {state.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <InputLabel id="beneficiary-district-label">District *</InputLabel>
                    <Select
                        labelId="beneficiary-district-label"
                        id="district"
                        name="district"
                        value={String(formData.district || "")}
                        label="District *"
                        onChange={handleSelectChange("district")}
                        disabled={!formData.state_id}
                    >
                        <MenuItem value="">--Select District--</MenuItem>
                        {districtList.map((district) => (
                            <MenuItem value={String(district.id)} key={district.id}>
                                {district.city}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="PIN Code *"
                        name="pin_code"
                        value={formData.pin_code || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ inputMode: "numeric", maxLength: 6 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Contact Person *"
                        name="contact_person"
                        value={formData.contact_person || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 50 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Email ID *"
                        name="email"
                        type="email"
                        value={formData.email || ""}
                        onChange={handleFormDataChange}
                        error={isEmailInvalid}
                        helperText={isEmailInvalid ? "Please enter a valid Email ID." : ""}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Mobile No *"
                        name="mobile"
                        value={formData.mobile || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ inputMode: "numeric", maxLength: 10 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Landline No"
                        name="landline_no"
                        value={formData.landline_no || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ inputMode: "numeric", maxLength: 15 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-6 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Address Line 1 *"
                        name="address_1"
                        value={formData.address_1 || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 200 }}
                        multiline
                        minRows={2}
                    />
                </FormControl>
            </div>
            <div className="col-md-6 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Address Line 2"
                        name="address_2"
                        value={formData.address_2 || ""}
                        onChange={handleFormDataChange}
                        multiline
                        minRows={2}
                    />
                </FormControl>
            </div>
        </div>
    );
};

export default BasicInformationFields;